/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface VideoContentUserThumbnails {
  /** 발송된 병원 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 병원ID */
  hospitalID?: string;
  /** 병원서비스ID */
  hserviceID?: string;
  /** 유저ID */
  userID?: string;
  /** 운동 콘텐츠 ID */
  vcID?: string;
  /** 병원-커스텀 운동 콘텐츠 ID */
  vchID?: string;
  /** 고객 운동콘텐츠 생성 순서를 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 운동 콘텐츠를 전송한 유저 이름 */
  writerName?: string;
  /** 운동 콘텐츠를 전송한 유저의 프로필 사진 ID */
  writerPhoto?: FilePaths;
  /** 운동콘텐츠 제목 */
  title?: string;
  /** 운동콘텐츠 부제목 */
  subtitle?: string;
  /** 운동콘텐츠 카테고리 (구  치료부위 카테고리) */
  categories?: VideoContentCategory[];
  /** 고객 운동콘텐츠 카테고리 이름 */
  categoryName?: any[];
  /** 운동 태그 */
  exerciseTag?: any[];
  /** 운동 난이도(레벨) */
  difficulty?: number;
  /** 고객 운동콘텐츠 검색키워드 */
  searchKeyword?: any[];
  /** 운동 종류 */
  exerciseType?: string;
  /** 자극 부위 */
  stimulateMuscles?: string;
  /** 자극부위 이미지 ID */
  stimulateMusclesImageID?: FilePaths;
  /** 운동 정보 */
  description?: string;
  /** 관련 질환 */
  relatedDiseases?: string;
  /** 운동 구성 */
  exerciseSet?: VideoContentExerciseSetFilePaths[];
  /** 준비물. */
  material?: VideoContentMaterialFilePaths[];
  /** 주의사항 */
  precaution?: string;
  /**
   * 일주일 중 실천할 횟수(주 n회)  기본값 주 3회
   * @default 3
   */
  doPerWeek?: number;
  /**
   * 처방기간 (n주 동안 진행)  기본값 2주
   * @default 2
   */
  duration?: number;
  /** 운동콘텐츠 이행 종료 날짜 */
  endDate?: string;
  /** 운동 콘텐츠 코멘트 */
  message?: string;
  /** 영상 썸네일 FileID */
  thumbnailFileID?: FilePaths;
  /** 영상 FileID */
  videoFileID?: string;
  /**
   * 운동 콘텐츠 중 세부동작 여부
   * @default false
   */
  isDetail?: boolean;
  /**
   * 숨김 처리 여부
   * @default false
   */
  isHidden?: boolean;
  /**
   * 운동콘텐츠 삭제 여부
   * @default false
   */
  isRemoved?: boolean;
  /**
   * 적합 여부
   * @default false
   */
  isRecommend?: boolean;
  /**
   * 환자의 최초 열람 여부
   * @default false
   */
  isRead?: boolean;
  /** 영상 전체길이 (단위 ms) */
  totalVideoLength?: number;
  /** 시청 횟수(고객 운동콘텐츠 기준) */
  viewCount?: number;
  /** 부분 시청 횟수 (고객 운동콘텐츠 기준) */
  partViewCount?: number;
  /** 이행 완료 횟수(고객 운동콘텐츠 기준) */
  completeViewCount?: number;
  /** 공유 횟수(고객 운동콘텐츠 기준) */
  shareCount?: number;
  /** 예약 횟수(고객 운동콘텐츠 기준  게스트 유저가 전화예약 버튼을 누른 횟수) */
  guestReservationCount?: number;
  /** 가장 최근에 action  view를 수행한 시간 */
  recentViewAt?: string;
  /** 기본콘텐츠 (가입시 -qr/releasePending- 자동 발송될 콘텐츠) 구분자 */
  isPending?: boolean;
  /**
   * 기본콘텐츠 - 다음 타이머 발송 차례를 표시하는 boolean
   * @default false
   */
  isNextVideo?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface FilePaths {
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths?: string[];
}

export interface VideoContentCategory {
  /** 홈케어 콘텐츠 카테고리 고유ID */
  _id?: string;
  /** 운동콘텐츠 카테고리명 */
  categoryName?: string;
  /** 병원ID */
  hospitalID?: string;
  /** 정렬순서 */
  sortNum?: number;
  /** 상위 카테고리 ID. */
  parentCategoryIDs?: string[];
  /** 카테고리 대 여부 */
  isTop?: boolean;
  /** 카테고리 중 여부 */
  isParent?: boolean;
  /** 숨김 처리 여부 */
  isHidden?: boolean;
  /** 카테고리별 기초 콘텐츠 여부 */
  isBasic?: boolean;
  /** 운동콘텐츠 카테고리에 대한 설명 (oo의원 전용 콘텐츠 등) */
  description?: string;
  /** 카테고리의 명칭 (부위, 난이도, ...) */
  typeName?: string;
  /** 컨디셔닝 영상 여부 */
  isConditioning?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface VideoContentExerciseSetFilePaths {
  /** 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 운동구성 내 운동 제목 */
  title?: string;
  /** 운동구성 내 운동 제목(영문) */
  titleEn?: string;
  /** 운동구성 내 운동 설명 */
  description?: number;
  /** 운동구성 내 썸네일 파일 ID */
  thumbnailFileID?: FilePaths;
  /** 운동구성 내 운동 시간(ms) */
  timestamp?: number;
}

export interface VideoContentMaterialFilePaths {
  /** 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 준비물명 */
  name?: string;
  /** 운동구성 내 썸네일 파일 ID */
  thumbnailFileID?: FilePaths;
}

export interface VideoContentUser {
  /** 발송된 병원 홈케어 콘텐츠 고유ID */
  _id?: string;
  /** 병원ID */
  hospitalID?: string;
  /** 병원서비스ID */
  hserviceID?: string;
  /** 유저ID */
  userID?: string;
  /** 운동 콘텐츠 ID */
  vcID?: string;
  /** 병원-커스텀 운동 콘텐츠 ID */
  vchID?: string;
  /** 고객 운동콘텐츠 생성 순서를 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 운동 콘텐츠를 전송한 유저 이름 */
  writerName?: string;
  /** 운동 콘텐츠를 전송한 유저의 프로필 사진 ID */
  writerPhoto?: string;
  /** 운동콘텐츠 제목 */
  title?: string;
  /** 운동콘텐츠 부제목 */
  subtitle?: string;
  /** 운동콘텐츠 카테고리 (구  치료부위 카테고리) */
  categories?: any[];
  /** 고객 운동콘텐츠 카테고리 이름 */
  categoryName?: any[];
  /** 운동 태그 */
  exerciseTag?: any[];
  /** 운동 난이도(레벨) */
  difficulty?: number;
  /** 고객 운동콘텐츠 검색키워드 */
  searchKeyword?: any[];
  /** 운동 종류 */
  exerciseType?: string;
  /** 자극 부위 */
  stimulateMuscles?: string;
  /** 자극부위 이미지 ID */
  stimulateMusclesImageID?: string;
  /** 운동 정보 */
  description?: string;
  /** 관련 질환 */
  relatedDiseases?: string;
  /** 운동 구성 */
  exerciseSet?: Record<string, any>[];
  /** 준비물. */
  material?: Record<string, any>[];
  /** 주의사항 */
  precaution?: string;
  /**
   * 일주일 중 실천할 횟수(주 n회)  기본값 주 3회
   * @default 3
   */
  doPerWeek?: number;
  /**
   * 처방기간 (n주 동안 진행)  기본값 2주
   * @default 2
   */
  duration?: number;
  /** 운동콘텐츠 이행 종료 날짜 */
  endDate?: string;
  /** 운동 콘텐츠 코멘트 */
  message?: string;
  /** 영상 썸네일 FileID */
  thumbnailFileID?: string;
  /** 영상 FileID */
  videoFileID?: string;
  /**
   * 운동 콘텐츠 중 세부동작 여부
   * @default false
   */
  isDetail?: boolean;
  /**
   * 숨김 처리 여부
   * @default false
   */
  isHidden?: boolean;
  /**
   * 운동콘텐츠 삭제 여부
   * @default false
   */
  isRemoved?: boolean;
  /**
   * 적합 여부
   * @default false
   */
  isRecommend?: boolean;
  /**
   * 환자의 최초 열람 여부
   * @default false
   */
  isRead?: boolean;
  /** 영상 전체길이 (단위 ms) */
  totalVideoLength?: number;
  /** 시청 횟수(고객 운동콘텐츠 기준) */
  viewCount?: number;
  /** 부분 시청 횟수 (고객 운동콘텐츠 기준) */
  partViewCount?: number;
  /** 이행 완료 횟수(고객 운동콘텐츠 기준) */
  completeViewCount?: number;
  /** 공유 횟수(고객 운동콘텐츠 기준) */
  shareCount?: number;
  /** 예약 횟수(고객 운동콘텐츠 기준  게스트 유저가 전화예약 버튼을 누른 횟수) */
  guestReservationCount?: number;
  /** 가장 최근에 action  view를 수행한 시간 */
  recentViewAt?: string;
  /** 기본콘텐츠 (가입시 -qr/releasePending- 자동 발송될 콘텐츠) 구분자 */
  isPending?: boolean;
  /**
   * 기본콘텐츠 - 다음 타이머 발송 차례를 표시하는 boolean
   * @default false
   */
  isNextVideo?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface ApiVideocontentuserElFindParams {
  /** (required) 고객의 병원서비스 ID */
  hserviceID: string;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiVideocontentuserElFindData = ApiResponse & {
  data: VideoContentUserThumbnails[];
};

export type ApiVideocontentuserElCreateData = ApiResponse & {
  data: VideoContentUser[];
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-VideoContentUser
     * @name ApiVideocontentuserElFind
     * @summary 고객별 홈케어 콘텐츠 목록 조회
     * @request GET:/v3/api/videocontentuser/el/find
     * @secure
     * @response `200` `ApiVideocontentuserElFindData` \[\{VideoContentUser\}\] 고객 홈케어 콘텐츠 컬렉션 객체 배열
     */
    apiVideocontentuserElFind: (query: ApiVideocontentuserElFindParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentuserElFindData, any>({
        path: `/v3/api/videocontentuser/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-VideoContentUser
     * @name ApiVideocontentuserElCreate
     * @summary 고객 홈케어 콘텐츠 신규 생성
     * @request POST:/v3/api/videocontentuser/el/create
     * @secure
     * @response `200` `ApiVideocontentuserElCreateData` \[\{VideoContentUser\}\] 생성된 고객 홈케어 콘텐츠 컬렉션 객체 배열
     */
    apiVideocontentuserElCreate: (
      data: {
        vchIDs?: {
          /** 고객에게 처방 내릴 병원 홈케어 콘텐츠 ID */
          vchID?: string;
          /** 일주일 중 실천할 횟수 (주 n회) */
          doPerWeek?: number;
          /** 처방기간 (n주 동안 진행) */
          duration?: number;
        }[];
        /** 병원 ID */
        hospitalID?: string;
        targetUsers?: {
          /** 고객의 유저 ID */
          userID?: string;
          /** 고객의 병원서비스 ID */
          hserviceID?: string;
        }[];
        /** 자동 발송일 경우 true로 작성. 이 때, lastVCUEndDate 를 업데이트 하지 않음. */
        isAutoSend?: boolean;
        /** 고객 홈케어 콘텐츠 코멘트 */
        message?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiVideocontentuserElCreateData, any>({
        path: `/v3/api/videocontentuser/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
